module.exports = __webpack_public_path__ + "static/apple-icon-180x180-4cceaaff5c96220eee4bb4786a990d64.png";